import React, { useState, useEffect } from "react";
import { MealsStatus, MealsTabProps } from "./MealsTab.props";
import { ORDER_STATUS } from "utils/Constants";
import "./style.scss";

const MealsTab = React.memo<MealsTabProps>(
    ({ handleActiveTab, defaultStatus, mealsStatus }) => {
        const [activeMeal, setActiveMeal] = useState(defaultStatus);

        const meals: MealsStatus[] = [
            {
                id: 1,
                name: "ناهار",
            },
            {
                id: 2,
                name: "شام",
            },
        ];

        useEffect(() => {
            setActiveMeal(defaultStatus);
        }, [defaultStatus]);

        const changeActiveMeal = (mealID: number) => {
            setActiveMeal(mealID);
            handleActiveTab(mealID);
        };

        let data = mealsStatus || meals;

        return (
            <div className="meals-tab-container">
                <div className="meals-item-wrapper" data-testid="meals-tab">
                    {data?.map((meal) => (
                        <div
                            className="meal-item"
                            key={meal.id}
                            onClick={() => changeActiveMeal(meal.id)}
                        >
                            <span
                                className={` ${
                                    meal.id === activeMeal
                                        ? "active"
                                        : meal.id !== activeMeal &&
                                          meal.status === ORDER_STATUS.changed
                                        ? "changedStatus"
                                        : ""
                                } `}
                            >
                                {meal.name}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
);

export default MealsTab;
